import EmptyView from "common/Empty/EmptyView";
import { MARKETPLACE_PATH } from "common/constants";
import React from "react";
import useHistoryWithQuery from "utils/hooks/useHistoryWithQuery";
import { SignalsEmptyStateProps } from "features/signals/common/types";
import { EmptyStatesType } from "common/Icons/types.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { joinWords } from "@shared/common/i18n/utils";
import { LanguageNameSpaces } from "@shared/types";

const SignalsEmptyState = ({
  isOpen,
  filtersSlice,
  hasData,
  numGroups,
  isSearch,
  size,
  isAdmin,
}: SignalsEmptyStateProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.SIGNALS);
  const { historyPush } = useHistoryWithQuery();
  const suggestOtherGroups = !isAdmin && (!numGroups || numGroups <= 1);
  // Admins' group count is only passed once known (new look).
  const noGroups = isAdmin ? numGroups === 0 : !numGroups;
  const statusKey = isOpen ? "open" : "closed";
  const emptyStateTitle = noGroups
    ? t("empty_states.no_groups_title")
    : t("empty_states.title", { status: t(`empty_states.${statusKey}`) });
  const emptyStateSubtitle = noGroups
    ? t("empty_states.no_groups_description")
    : t("empty_states.description");

  return (
    <EmptyView
      iconKey={noGroups ? EmptyStatesType.Marketplace : EmptyStatesType.Signals}
      iconWidth={size ?? 140}
      title={emptyStateTitle}
      description={suggestOtherGroups ? emptyStateSubtitle : undefined}
      buttonText={
        suggestOtherGroups ? t("empty_states.find_a_group") : undefined
      }
      buttonOnClick={
        suggestOtherGroups ? () => historyPush(MARKETPLACE_PATH) : undefined
      }
      objectName={joinWords([
        t(`empty_states.${statusKey}`),
        t("table.item_type"),
      ])}
      isSearch={isSearch}
      filtersSlice={filtersSlice}
      hasData={hasData}
    />
  );
};

export default SignalsEmptyState;
